export default __webpack_public_path__ + "static/media/mp4.f258472d.svg";